// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3BQ6_","small":"Card_small__1yJRk","big":"Card_big__1Zr3l"};